import { Input } from 'antd';
import type { InputProps } from 'antd';

export interface DInputProps extends InputProps {}

export const DarwinInput = (props: DInputProps) => {
  return <Input {...props} />;
};
